import MatchStatusBadge from "./MatchStatusBadge";
import Button from "@components/ui/Button";

function formatDate(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function formatDuration(seconds) {
  if (seconds == null) return "-";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export default function AppointmentsPanel({
  appointments,
  selectedAppointmentId,
  onSelect,
  onUnmatch,
  actionLoading,
}) {
  if (!appointments.length) {
    return (
      <div className="border rounded-lg p-6 text-center text-gray-500 text-sm">
        No appointments found.
      </div>
    );
  }

  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="bg-gray-50 px-4 py-2 border-b">
        <h2 className="text-sm font-semibold text-gray-700">Appointments</h2>
      </div>
      <div className="divide-y max-h-[60vh] overflow-y-auto">
        {appointments.map((appt) => {
          const matched = !!appt.unifi_call_log_id;
          const isSelected = selectedAppointmentId === appt.id;

          return (
            <div
              key={appt.id}
              className={`px-4 py-3 flex items-start gap-3 cursor-pointer transition-colors ${
                isSelected
                  ? "bg-blue-50 border-l-2 border-blue-500"
                  : "hover:bg-gray-50"
              }`}
              onClick={() => {
                if (!matched) onSelect(isSelected ? null : appt.id);
              }}
            >
              {/* Radio indicator for unmatched */}
              {!matched && (
                <div className="mt-1 flex-shrink-0">
                  <div
                    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                      isSelected
                        ? "border-blue-500"
                        : "border-gray-300"
                    }`}
                  >
                    {isSelected && (
                      <div className="w-2 h-2 rounded-full bg-blue-500" />
                    )}
                  </div>
                </div>
              )}

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium text-sm text-gray-900 truncate">
                    {appt.patient_name}
                  </span>
                  <MatchStatusBadge matched={matched} />
                </div>
                <p className="text-xs text-gray-500 mt-0.5">
                  Created: {formatDate(appt.created_at)}
                </p>
                <p className="text-xs text-gray-500">
                  Status: {appt.status || "-"}
                </p>
                {appt.phone_number && (
                  <p className="text-xs text-gray-500">
                    Phone: {appt.phone_number}
                  </p>
                )}
                {appt.callback_phone_number && (
                  <p className="text-xs text-gray-500">
                    Callback: {appt.callback_phone_number}
                  </p>
                )}
                {appt.call_metadata_duration_secs != null && (
                  <p className="text-xs text-gray-500">
                    Call duration: {formatDuration(appt.call_metadata_duration_secs)}
                  </p>
                )}
                {matched && (
                  <p className="text-xs text-gray-500">
                    Matched call: {appt.call_from_number} ({appt.call_duration_seconds}s)
                  </p>
                )}
              </div>

              {matched && (
                <Button
                  color="light"
                  size="xs"
                  disabled={actionLoading}
                  onClick={(e) => {
                    e.stopPropagation();
                    onUnmatch(appt.id);
                  }}
                >
                  Unmatch
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
